import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";

import { TextConstants } from "@shared/constants";

@Component({
  standalone: false,
  selector: "app-reports-eudr-commodity-info",
  templateUrl: "./reports-eudr-commodity-info.component.html",
  styleUrls: ["./reports-eudr-commodity-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ReportsEudrCommodityInfoComponent {
  @Input() index: number;

  @Input() formGroup: FormGroup;

  public readonly translations: any = {
    netMassTooltip: $localize`:@@eudr.help:Cannot display the sum, as not all items in this product group are measured in either Volume or Mass.`,
    netMassLabel: TextConstants.NET_MASS_KG,
    volumeLabel: TextConstants.VOLUME_M3,
    descriptionLabel: $localize`:@@eudr.commoditiesorproductsdescription:Commodity(-ies) or Product(s) Description`,
  };

  public get producersInfoFormGroups(): FormGroup[] {
    return this.producersInfoFormArray.controls as FormGroup[];
  }

  public get materialsInfoFormGroups(): FormGroup[] {
    return this.materialsInfoFormArray.controls as FormGroup[];
  }

  public get displayFields(): boolean {
    return this.producersInfoFormArray.value.length;
  }

  private get producersInfoFormArray(): FormArray {
    return this.formGroup["controls"]["producersInfo"] as FormArray;
  }

  private get materialsInfoFormArray(): FormArray {
    return this.formGroup["controls"]["materialsInfo"] as FormArray;
  }
}
